const standards = [
  {
    label: '01',
    title: 'Clean Architecture',
    description: 'Separation of concerns, modular design, and testable codebases built for long-term evolution.',
  },
  {
    label: '02',
    title: 'Performance Optimization',
    description: 'System-level efficiency, resource management, and responsive design at every tier.',
  },
  {
    label: '03',
    title: 'User-Centered Design',
    description: 'Intuitive interfaces built around real user needs, behaviors, and accessibility standards.',
  },
  {
    label: '04',
    title: 'Continuous Innovation',
    description: 'Exploring new technologies and evolving development workflows to stay ahead.',
  },
  {
    label: '05',
    title: 'Engineering Excellence',
    description: 'Adopting up-to-date standards for reliable, future-ready software solutions.',
  },
];

export default function StandardsSection() {
  return (
    <section className="w-full bg-background-100 py-20 md:py-32">
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-12">
        <div className="flex items-baseline gap-3 mb-3">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
            Technical
          </h2>
          <span className="text-3xl md:text-4xl font-bold font-heading text-accent-500">
            Standards
          </span>
        </div>
        <p className="text-sm text-foreground-500 font-body mb-14">
          The disciplines that define how we work
        </p>

        <div className="flex gap-6 overflow-x-auto pb-4 -mx-6 px-6 md:-mx-12 md:px-12 scrollbar-hide" style={{ scrollSnapType: 'x mandatory' }}>
          {standards.map((item) => (
            <div
              key={item.label}
              className="flex-shrink-0 w-[280px] bg-background-50 rounded-2xl border border-background-200/60 p-6 flex flex-col"
              style={{ scrollSnapAlign: 'start' }}
            >
              <div className="w-full h-40 rounded-xl mb-5 overflow-hidden" style={{ background: 'linear-gradient(135deg, oklch(0.92 0.008 88), oklch(0.86 0.012 86))' }}>
                <div className="w-full h-full flex items-center justify-center">
                  <div className="w-16 h-[1px] bg-foreground-200 rotate-45"></div>
                  <div className="w-16 h-[1px] bg-foreground-200 -rotate-45 -ml-16"></div>
                  <div className="w-10 h-10 rounded-full border border-foreground-200/50 -ml-10"></div>
                </div>
              </div>
              <h3 className="text-base font-semibold font-heading text-foreground-950 leading-snug">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 font-body leading-relaxed mt-2 flex-1">
                {item.description}
              </p>
              <p className="text-2xl font-bold font-heading text-foreground-950 mt-4 text-right">
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}